import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./home.scss";

import Sectionfive from "./Sectionfive";
import Sectionfour from "./Sectionfour";
import Sectionthree from "./Sectionthree";
import SectionthreePoint1 from "./SectionthreePoint1";
import Sectiontwo from "./Sectiontwo";
import Slider from "./slider";
function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    // Example of lazy loading images
    const lazyImages = document.querySelectorAll('.lazy');

    const lazyLoad = target => {
      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            const src = img.getAttribute('data-src');
            img.setAttribute('src', src);
            observer.disconnect();
          }
        });
      });

      io.observe(target);
    };

    lazyImages.forEach(lazyLoad);
  }, [])
  return (
    <div className="Home">
      <Helmet>
        <link rel="canonical" href="https://www.ggilab.com/" />
        <title>Galaxy Gemological Institute | CERTIFIED GEMSTONES TESTERS</title>
        <meta
          name="description"
          content="Galaxy Gemological Institute is the first laboratory in Pakistan to provide verification of gemstone certificates. GGI laboratory is a pioneer to seal diamonds and gemstones. Contact Us!"
        />
      </Helmet>
      <Slider />
      <Sectiontwo />
      <Sectionthree />
      <SectionthreePoint1 />
      <Sectionfour />
      <Sectionfive />
    </div>
  );
}
const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);
